import { useState } from "react";
import { 
  GlobalVariableRegistry,
  ClipboardData,
  Action
} from "../utils/types";
import { ContextMenuState, CanvasContextMenuState, EdgeContextMenuState } from "./types";

// Hook for managing core tree state  
export const useTreeState = () => {
  const [globalVariableRegistry, setGlobalVariableRegistry] = useState<GlobalVariableRegistry>({});
  const [identifiers, setIdentifiers] = useState<string[]>([]);
  
  // Clipboard and context menu state - moved here from useModalStates
  const [clipboard, setClipboard] = useState<ClipboardData>({
    type: null,
    sourceId: null,
    sourceNode: null,
    sourceBranch: null,
    sourceEdges: null,
    highlighted: []
  });
  
  const [contextMenu, setContextMenu] = useState<ContextMenuState>({
    visible: false,
    x: 0,
    y: 0,
    nodeId: null,
  });
  
  const [canvasContextMenu, setCanvasContextMenu] = useState<CanvasContextMenuState>({
    visible: false,
    x: 0,
    y: 0,
    screenPosition: { x: 0, y: 0 },
  });

  const [edgeContextMenu, setEdgeContextMenu] = useState<EdgeContextMenuState>({
    visible: false,
    edgeId: null,
    sourceId: null,
    targetId: null,
    screenPosition: { x: 0, y: 0 },
  });
  
  // History state
  const [actionHistory, setActionHistory] = useState<Action[]>([]);
  
  // Node tracking state
  const [nodeDimensions, setNodeDimensions] = useState<Record<string, number>>({});
  const [manuallyMovedNodes, setManuallyMovedNodes] = useState<Set<string>>(new Set());
  
  // Reactive state flag
  const [shouldRepositionAfterNodeAddition, setShouldRepositionAfterNodeAddition] = useState(false);
  
  return {
    globalVariableRegistry,
    setGlobalVariableRegistry,
    identifiers,
    setIdentifiers,
    clipboard,
    setClipboard,
    contextMenu,                // Added
    setContextMenu,             // Added
    canvasContextMenu,
    setCanvasContextMenu,
    edgeContextMenu,
    setEdgeContextMenu,
    actionHistory,
    setActionHistory,
    nodeDimensions,
    setNodeDimensions,
    manuallyMovedNodes,
    setManuallyMovedNodes,
    shouldRepositionAfterNodeAddition,
    setShouldRepositionAfterNodeAddition,
  };
};